var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClothSeats24 = function SvgClothSeats24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63 2h4.11a1.7 1.7 0 0 1 1.04.35c.295.228.5.546.58.901.452 2.052 2.006 6.012 7.317 7.031.373.073.709.268.95.552.24.283.372.638.372 1.004v8.574c0 .421-.174.825-.484 1.123-.31.298-.73.465-1.169.465H5.653c-.439 0-.86-.167-1.169-.465A1.557 1.557 0 0 1 4 20.412V3.582c.002-.417.173-.816.478-1.111A1.686 1.686 0 0 1 5.63 2v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.002 5S8.63 11.434 17 13.466V19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.62 3.28 2.62 3.28 2.62 3.28"
  })));
};
export default SvgClothSeats24;